import React from 'react';
import '../styles/WheelLoaders.css';

const WheelLoaders = () => {
  return (
    <section className="wheel-loaders">
      <div className="loader-container">
        <div className="loader-text">
          <h2 className="loader-title">CHARGEUSES</h2>
          <h3 className="loader-specs">SUR PNEUS 2 À 4,5 M3</h3>
          <p className="loader-tagline">" Alliez maniabilité et performance "</p>
          
          <div className="loader-description">
            <p>
              Nos chargeuses sur pneus sont idéales pour les travaux intensifs. 
              Grâce à leurs moteurs puissants et leur capacité de chargement adaptée, 
              elles sont conçues pour booster votre productivité.
            </p>
          </div>
          
          <a href="/products/loader" className="loader-button">
            NOS CHARGEUSES
          </a>
        </div>
        
        <div className="loader-image">
          <img 
            src="/assets/images/chargeuse.png" 
            alt="Chargeuse LiuGong" 
          />
        </div>
      </div>
    </section>
  );
};

export default WheelLoaders;